var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65718 16.3144C7.79659 16.3144 6.22191 15.67 4.93314 14.3812C3.64438 13.0925 3 11.5178 3 9.65718C3 7.79659 3.64438 6.22191 4.93314 4.93314C6.22191 3.64438 7.79659 3 9.65718 3C11.5178 3 13.0925 3.64438 14.3812 4.93314C15.67 6.22191 16.3144 7.79659 16.3144 9.65718C16.3144 10.4083 16.1949 11.1166 15.9559 11.7824C15.7169 12.4481 15.3926 13.037 14.9829 13.5491L20.7184 19.2845C20.9061 19.4723 21 19.7112 21 20.0014C21 20.2916 20.9061 20.5306 20.7184 20.7184C20.5306 20.9061 20.2916 21 20.0014 21C19.7112 21 19.4723 20.9061 19.2845 20.7184L13.5491 14.9829C13.037 15.3926 12.4481 15.7169 11.7824 15.9559C11.1166 16.1949 10.4083 16.3144 9.65718 16.3144ZM9.65718 14.266C10.9374 14.266 12.0256 13.8179 12.9218 12.9218C13.8179 12.0256 14.266 10.9374 14.266 9.65718C14.266 8.37696 13.8179 7.28876 12.9218 6.3926C12.0256 5.49644 10.9374 5.04836 9.65718 5.04836C8.37696 5.04836 7.28876 5.49644 6.3926 6.3926C5.49644 7.28876 5.04836 8.37696 5.04836 9.65718C5.04836 10.9374 5.49644 12.0256 6.3926 12.9218C7.28876 13.8179 8.37696 14.266 9.65718 14.266Z",
    fill: "#050220"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5271d54a8133da23b9c0166fe6baf988.svg";
export { ForwardRef as ReactComponent };